export const environment = {
  production: false,
  apiProjectUrl: 'https://a314-projects-qa.evepark.avwaveinteractive.com/projects',
  apiUrlAdmin: 'https://a314-admin-users-qa.evepark.avwaveinteractive.com/admin-users',
  apiGoogleStorage: 'https://a314-google-storage-qa.evepark.avwaveinteractive.com/storage',
  urlStorage: 'https://evepark-avwave-dev.storage.googleapis.com/',
  testUser: {
    // tslint:disable-line
    token: 'cualquiercosa',
    email: 'user@user.user',
  },
};
